import { useEffect, useRef, useState } from 'react';

export const useScrollArrows = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down'>('down');

  const checkScrollable = () => {
    const container = containerRef.current;
    if (!container) return;

    const isTop = container.scrollTop === 0;
    const isBottom =
      container.scrollTop + container.clientHeight >= container.scrollHeight;

    const scrollable = container.scrollHeight > container.clientHeight;
    setIsScrollable(scrollable);
    setScrollDirection((prev) => (isTop ? 'down' : isBottom ? 'up' : prev));
  };

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      container.addEventListener('scroll', checkScrollable);
      checkScrollable();
    }

    return () => container?.removeEventListener('scroll', checkScrollable);
  }, [scrollDirection]);

  const handleArrowClick = () => {
    const container = containerRef.current;

    if (!container) return;

    container.scrollTo({
      top: scrollDirection === 'down' ? container.scrollHeight : 0,
      behavior: 'smooth',
    });
  };

  return {
    containerRef,
    isScrollable,
    scrollDirection,
    handleArrowClick,
    checkScrollable,
  };
};
